
export default function FourOfFour() {
    return (
        <>
            <h1>404 error</h1>
        </>
    )
}